var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showErrorMessage ? _vm._t("errorMessage") : _vm._e(),
      _vm._v(" "),
      _vm.jobDetails
        ? [
            _c("div", { staticClass: "hero-back__overflow-content" }, [
              _c("div", { staticClass: "hero-text" }, [
                _c(
                  "div",
                  { staticClass: "hero-text-wrapper" },
                  [
                    _vm._t("backLink"),
                    _vm._v(" "),
                    _c("h3", { staticClass: "hero-text__h3" }, [
                      _vm._v(_vm._s(_vm.jobDetails.title)),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "hero-text__p" }, [
                      _vm._v(
                        "Jelentkezési határidő: " +
                          _vm._s(_vm.jobDetails.deadline)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hero-text-labels" }, [
                      _c("span", { staticClass: "hero-text-labels__item" }, [
                        _vm._v(_vm._s(_vm.jobDetails.location)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "hero-text-labels__item" }, [
                        _vm._v(_vm._s(_vm.jobDetails.company)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "hero-text-labels__item" }, [
                        _vm._v(_vm._s(_vm.jobDetails.type)),
                      ]),
                    ]),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "details-boxes" }, [
              _c("div", { staticClass: "details-boxes-wrapper" }, [
                (_vm.jobDetails.content2 && _vm.jobDetails.content3) ||
                (_vm.jobDetails.content4 && _vm.jobDetails.content5)
                  ? _c("div", { staticClass: "details-boxes__box" }, [
                      _vm.jobDetails.content2 && _vm.jobDetails.content3
                        ? _c(
                            "div",
                            { staticClass: "details-boxes__list-wrapper" },
                            [
                              _c(
                                "p",
                                { staticClass: "details-boxes__list-title" },
                                [_vm._v(_vm._s(_vm.jobDetails.content2))]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "details-boxes__list" },
                                _vm._l(
                                  _vm.jobDetails.content3,
                                  function (item, index) {
                                    return _c("li", {
                                      key: index,
                                      staticClass: "details-boxes__list-item",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.sanitize(item)),
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.jobDetails.content4 && _vm.jobDetails.content5
                        ? _c(
                            "div",
                            { staticClass: "details-boxes__list-wrapper" },
                            [
                              _c(
                                "p",
                                { staticClass: "details-boxes__list-title" },
                                [_vm._v(_vm._s(_vm.jobDetails.content4))]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "details-boxes__list" },
                                _vm._l(
                                  _vm.jobDetails.content5,
                                  function (item, index) {
                                    return _c("li", {
                                      key: index,
                                      staticClass: "details-boxes__list-item",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.sanitize(item)),
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                (_vm.jobDetails.content6 && _vm.jobDetails.content7) ||
                (_vm.jobDetails.content8 && _vm.jobDetails.content9)
                  ? _c("div", { staticClass: "details-boxes__box" }, [
                      _vm.jobDetails.content6 && _vm.jobDetails.content7
                        ? _c(
                            "div",
                            { staticClass: "details-boxes__list-wrapper" },
                            [
                              _c(
                                "p",
                                { staticClass: "details-boxes__list-title" },
                                [_vm._v(_vm._s(_vm.jobDetails.content6))]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "details-boxes__list" },
                                _vm._l(
                                  _vm.jobDetails.content7,
                                  function (item, index) {
                                    return _c("li", {
                                      key: index,
                                      staticClass: "details-boxes__list-item",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.sanitize(item)),
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.jobDetails.content8 && _vm.jobDetails.content9
                        ? _c(
                            "div",
                            { staticClass: "details-boxes__list-wrapper" },
                            [
                              _c(
                                "p",
                                { staticClass: "details-boxes__list-title" },
                                [_vm._v(_vm._s(_vm.jobDetails.content8))]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "details-boxes__list" },
                                _vm._l(
                                  _vm.jobDetails.content9,
                                  function (item, index) {
                                    return _c("li", {
                                      key: index,
                                      staticClass: "details-boxes__list-item",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.sanitize(item)),
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                (_vm.jobDetails.content10 && _vm.jobDetails.content11) ||
                (_vm.jobDetails.content12 && _vm.jobDetails.content13)
                  ? _c("div", { staticClass: "details-boxes__box" }, [
                      _vm.jobDetails.content10 && _vm.jobDetails.content11
                        ? _c(
                            "div",
                            { staticClass: "details-boxes__list-wrapper" },
                            [
                              _c(
                                "p",
                                { staticClass: "details-boxes__list-title" },
                                [_vm._v(_vm._s(_vm.jobDetails.content10))]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "details-boxes__list" },
                                _vm._l(
                                  _vm.jobDetails.content11,
                                  function (item, index) {
                                    return _c("li", {
                                      key: index,
                                      staticClass: "details-boxes__list-item",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.sanitize(item)),
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.jobDetails.content12 && _vm.jobDetails.content13
                        ? _c(
                            "div",
                            { staticClass: "details-boxes__list-wrapper" },
                            [
                              _c(
                                "p",
                                { staticClass: "details-boxes__list-title" },
                                [_vm._v(_vm._s(_vm.jobDetails.content12))]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "details-boxes__list" },
                                _vm._l(
                                  _vm.jobDetails.content13,
                                  function (item, index) {
                                    return _c("li", {
                                      key: index,
                                      staticClass: "details-boxes__list-item",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.sanitize(item)),
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                (_vm.jobDetails.content14 && _vm.jobDetails.content15) ||
                (_vm.jobDetails.content16 && _vm.jobDetails.content17)
                  ? _c("div", { staticClass: "details-boxes__box" }, [
                      _vm.jobDetails.content14 && _vm.jobDetails.content15
                        ? _c(
                            "div",
                            { staticClass: "details-boxes__list-wrapper" },
                            [
                              _c(
                                "p",
                                { staticClass: "details-boxes__list-title" },
                                [_vm._v(_vm._s(_vm.jobDetails.content14))]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "details-boxes__list" },
                                _vm._l(
                                  _vm.jobDetails.content15,
                                  function (item, index) {
                                    return _c("li", {
                                      key: index,
                                      staticClass: "details-boxes__list-item",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.sanitize(item)),
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.jobDetails.content16 && _vm.jobDetails.content17
                        ? _c(
                            "div",
                            { staticClass: "details-boxes__list-wrapper" },
                            [
                              _c(
                                "p",
                                { staticClass: "details-boxes__list-title" },
                                [_vm._v(_vm._s(_vm.jobDetails.content16))]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "details-boxes__list" },
                                _vm._l(
                                  _vm.jobDetails.content17,
                                  function (item, index) {
                                    return _c("li", {
                                      key: index,
                                      staticClass: "details-boxes__list-item",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.sanitize(item)),
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "details-boxes__box" }, [
                  _c("p", { staticClass: "details-boxes__list-title" }, [
                    _vm._v(_vm._s(_vm.jobDetails.content18)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "details-boxes__profile" }, [
                    _c("img", {
                      staticClass: "details-boxes-profile__img",
                      attrs: {
                        src: _vm.jobDetails.recruiter.image,
                        alt: "profile",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "details-boxes-profile__data" }, [
                      _c("p", { staticClass: "details-boxes-profile__text" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.jobDetails.recruiter.name)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "details-boxes-profile__text" }, [
                        _vm._v(_vm._s(_vm.jobDetails.recruiter.position)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "details-boxes-profile__text",
                          attrs: {
                            href: _vm.jobDetails.recruiter.linkedInUrl,
                            target: "_blank",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.jobDetails.recruiter.linkedInHyperText)
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "job-details__interested-in" }, [
              _c("h3", { staticClass: "job-details-interested-in__title" }, [
                _vm._v(_vm._s(_vm.jobDetails.content20)),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "job-details-interested-in__button btn-3-5 btn-full-magenta",
                  attrs: { href: _vm.jobDetails.applyUrl },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.jobDetails.content20 == "Érdekel? Vágj bele!"
                        ? "Jelentkezem"
                        : "Apply now"
                    )
                  ),
                ]
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }